import { createSelector } from '@reduxjs/toolkit';
import cookie from 'react-cookies';
import {
  UserState,
  UserActionTypes,
  QuipUser,
  UserById,
  LOGGED_IN,
  LOGGED_OUT,
  SET_USERS,
  CLEAR_USERS,
  UPDATE_USERS,
  RootState,
} from '../types';

import LoopbackProvider from '../../loopback/LoopbackProvider';

export const initialState: UserState = {
  token: undefined,
  byId: undefined,
  allIds: undefined,
};

function setNormalizedUsers(state: UserState, userList: QuipUser[]): UserState {
  const allIds: number[] = [];
  const byId = userList.reduce((accumulator, current) => {
    accumulator[current.id] = current;
    allIds.push(current.id);
    return accumulator;
  }, {} as UserById);
  return {
    ...state,
    byId,
    allIds,
  };
}

function updateNormalizedUsers(state: UserState, userList: QuipUser[]): UserState {
  const updatedUsers = userList.reduce((accumulator, current) => {
    accumulator[current.id] = current;
    return accumulator;
  }, {} as UserById);
  const newState = {
    ...state,
    byId: {
      ...state.byId,
      ...updatedUsers,
    },
  } as UserState;
  return newState;
}

export default (state = initialState, action: UserActionTypes): UserState => {
  switch (action.type) {
    case LOGGED_IN: {
      const token = { ...action.payload.token, email: action.payload.email };
      LoopbackProvider.loopbackToken = token;
      cookie.save('token', token, { path: '/' });
      return {
        ...state,
        token,
      };
    }
    case LOGGED_OUT:
      LoopbackProvider.loopbackToken = '';
      cookie.remove('token', {
        path: '/',
      });
      return {
        ...state,
        token: undefined,
        byId: undefined,
        allIds: undefined,
      };
    case SET_USERS:
      return setNormalizedUsers(state, action.payload);
    case CLEAR_USERS:
      return {
        ...state,
        byId: undefined,
        allIds: undefined,
      };
    case UPDATE_USERS:
      return updateNormalizedUsers(state, action.payload);
    default:
      return state;
  }
};

/** ----------- Selectors ----------- */
const selectUserRoles = (state: RootState) => state.users.token?.roles;
export const selectIsEditorPrivileged = createSelector([
  selectUserRoles,
], (roles) => !!roles?.includes('editorPrivileged'));
